import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
var firebaseConfig = {
   apiKey: "AIzaSyB4TaE4nip2tPCJl94NL9dcmGhEDU3yLJk",
    authDomain: "cardsmith-dev.firebaseapp.com",
    databaseURL: "https://cardsmith-dev.firebaseio.com",
    projectId: "firebase-cardsmith-dev",
    storageBucket: "firebase-cardsmith-dev.appspot.com",
    messagingSenderId: "561515761829",
    appId: "1:561515761829:web:6d5cc49297d4ce60603d4c"
};

//  var firebaseConfig = {
//    apiKey: 'AIzaSyAXvMD1l1TNeesMnY296_uQ3Tiz_SEZ4OU',
//    authDomain: "www.gocardsmith.co",
//    databaseURL: "https://cardsmith.firebaseio.com",
//    projectId: "firebase-cardsmith",
//    storageBucket: "firebase-cardsmith.appspot.com",
//    messagingSenderId: "707845313764",
//    appId: "1:707845313764:web:7917dbf8841cff7ae708f1",
//    measurementId: "UA-103775312-1"
//   };

export const app = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.database();
